module.exports = __webpack_public_path__ + "static/media/reward-second.2a9d6352.svg";